import { useMemo } from 'react';

import {
  formatModeListId,
  GENERATION_MODE_TYPE,
  getDefaultGenerationModeDescription,
  getDefaultGenerationModeLabel,
  getGenerationModeDescription,
  getGenerationModeLabel,
} from 'src/data/generation';

export const usePreparedModes = (generationTool, visibleDDTemplates, brandVoicesAssets) => {
  return useMemo(() => {
    const result = [];
    const restCommonModes = [...(visibleDDTemplates || [])];
    const firstCommonMode = restCommonModes.shift();

    const firstCommonDescription = getDefaultGenerationModeDescription(
      firstCommonMode,
      generationTool
    );

    // First mode should always have "Default" label and default description
    const firstCommonModeData = {
      id: formatModeListId(firstCommonMode, GENERATION_MODE_TYPE.common),
      realId: firstCommonMode,
      type: GENERATION_MODE_TYPE.common,
      title: getDefaultGenerationModeLabel(firstCommonMode, generationTool),
      description: firstCommonDescription,
    };

    result.push(firstCommonModeData);
    // Then the rest of common modes
    const restCommonModesDataList = restCommonModes.map((mode) => {
      const globalHint = getGenerationModeDescription(mode, generationTool);
      const description = globalHint;

      return {
        id: formatModeListId(mode, GENERATION_MODE_TYPE.common),
        realId: mode,
        type: GENERATION_MODE_TYPE.common,
        title: getGenerationModeLabel(mode, generationTool),
        description,
      };
    });

    result.push(...restCommonModesDataList);

    const preparedBrandVoicesAssets = brandVoicesAssets.map(({ id, name, customFormulas }) => {
      const preparedCustomFormulas = customFormulas
        ?.filter((ta) => ta.generationTool === generationTool)
        .map(({ id, name, body }) => {
          return {
            id: formatModeListId(id, GENERATION_MODE_TYPE.customFormula),
            realId: id,
            type: GENERATION_MODE_TYPE.customFormula,
            title: name,
            description: body,
          };
        });
      return {
        id,
        name,
        customFormulas: preparedCustomFormulas,
      };
    });

    return { modes: result, preparedBrandVoicesAssets };
  }, [generationTool, visibleDDTemplates, brandVoicesAssets]);
};
